import polyglotI18nProvider from "ra-i18n-polyglot";
import { adminMessages } from "./buildMessages";
import {
  ADMIN_LANG_NAMES,
  ADMIN_LANGS,
  ADMIN_LOCALE_STORAGE_KEY,
  type AdminLang,
} from "./labels";

export { ADMIN_LOCALE_STORAGE_KEY };

export const detectAdminLocale = (): AdminLang => {
  const stored = localStorage.getItem(ADMIN_LOCALE_STORAGE_KEY);
  if (stored && ADMIN_LANGS.includes(stored as AdminLang)) return stored as AdminLang;
  const browser = navigator.language.split("-")[0].toLowerCase();
  if (ADMIN_LANGS.includes(browser as AdminLang)) return browser as AdminLang;
  return "ru";
};

export const i18nProvider = polyglotI18nProvider(
  (locale: string) => (adminMessages[locale as AdminLang] ?? adminMessages.ru) as never,
  detectAdminLocale(),
  ADMIN_LANGS.map((locale) => ({ locale, name: ADMIN_LANG_NAMES[locale] })),
);
